/**
 * Tüm projeler: kendi ürünlerim ve müşteri işleri.
 * Linkler 23 Ekim 2026'da tek tek kontrol edildi; yalnızca açılanlar listede.
 * Kaldırılmış mağaza sayfaları (ör. App Store'dan kalkan uygulamalar) bilerek yok.
 */

// Kendi ürünlerim
import sonoraCrowd from "../assets/images/photos/sonora-crowd.jpg";
import sonoraInApp from "../assets/images/sonora_in_app.png";
import sonoraScreen1 from "../assets/images/projects/sonora-screen-1.png";
import sonoraScreen2 from "../assets/images/projects/sonora-screen-2.jpg";
import sonoraGirl from "../assets/images/projects/sonora-girl.jpg";
import funoDesk from "../assets/images/photos/funo-desk.jpg";
import funoInApp from "../assets/images/funo_in_app.png";
import funoKeyart from "../assets/images/projects/funo-keyart.webp";
import tattooPortrait from "../assets/images/photos/tattoo-portrait.jpg";
import tattooInApp from "../assets/tattoo-ai-inapp.png";
import meriastroSky from "../assets/images/photos/meriastro-sky.jpg";
import meriastroMockup from "../assets/images/meriastro_mockup.png";
import revoaiInterior from "../assets/images/photos/revoai-interior.jpg";
import revoaiMockup from "../assets/images/revoai-mockup.png";
import plusoneCapsule from "../assets/images/projects/plusone-capsule.jpg";
import plusoneDinner from "../assets/images/projects/plusone-dinner.jpg";
import plusoneChase from "../assets/images/projects/plusone-chase.jpg";
import plusonePoster from "../assets/images/projects/plusone-poster.jpg";
import enclaveShot from "../assets/images/projects/enclave-shot.jpg";

// Müşteri işleri
import supsisInbox from "../assets/images/projects/supsis-inbox.png";
import supsisWidget from "../assets/images/projects/supsis-widget.png";
import supsisLogo from "../assets/images/projects/supsis-logo.png";
import enterupReports from "../assets/images/projects/enterup-reports.jpg";
import enterupDashboard from "../assets/images/projects/enterup-dashboard.jpg";
import enterupKanban from "../assets/images/projects/enterup-kanban.jpg";
import enterupLogo from "../assets/images/projects/enterup-logo.png";
import healifeStore1 from "../assets/images/projects/healife-store-1.jpg";
import healifeStore2 from "../assets/images/projects/healife-store-2.jpg";
import healifeGym from "../assets/images/projects/healife-gym.webp";
import healifeLogo from "../assets/images/projects/healife-logo.svg";
import finrendPhone from "../assets/images/projects/finrend-phone.png";
import finrendDesktop from "../assets/images/projects/finrend-desktop.jpg";
import finrendIcon from "../assets/images/projects/finrend-icon.png";
import wecosmeticHome from "../assets/images/projects/wecosmetic-home.jpg";
import wecosmeticHero from "../assets/images/projects/wecosmetic-hero.png";
import eservisLogo from "../assets/images/projects/eservis-logo.png";
import valenturaLogo from "../assets/images/projects/valentura-logo.png";

// Eski müşteri işleri (mevcut görseller)
import vocanFeature from "../assets/images/vocan/vocan-feature.png";
import vocanPhoto1 from "../assets/images/vocan/1.png";
import vocanPhoto2 from "../assets/images/vocan/1242x2208bb.png";
import aybuFeature from "../assets/images/aybumobile/aybumobile-feature.png";
import aybuPhoto1 from "../assets/images/aybumobile/1242x2688bb (1).png";
import aybuPhoto2 from "../assets/images/aybumobile/1242x2688bb (2).png";
import playlandFeature from "../assets/images/playland/playland-feature.png";
import playlandPhoto1 from "../assets/images/playland/1242x2208bb (11).png";
import playlandPhoto2 from "../assets/images/playland/1242x2208bb (12).png";
import tgoFeature from "../assets/images/turkiye-genclik-odulleri/turkiye-genclik-odulleri-feature.png";
import tgoPhoto1 from "../assets/images/turkiye-genclik-odulleri/1242x2208bb (14).png";
import tgoPhoto2 from "../assets/images/turkiye-genclik-odulleri/1242x2208bb (15).png";
import funlordFeature from "../assets/images/funlord/funlord-feature.png";
import funlordPhoto1 from "../assets/images/funlord/photo1.png";
import funlordPhoto2 from "../assets/images/funlord/photo2.png";
import noorFeature from "../assets/images/noor/noor-feature.png";
import noorPhoto1 from "../assets/images/noor/1242x2208bb (8).png";
import noorPhoto2 from "../assets/images/noor/1242x2208bb (9).png";
import filminnFeature from "../assets/images/filminn/filminn-feature.png";
import filminnPhoto1 from "../assets/images/filminn/unnamed (1).webp";
import filminnPhoto2 from "../assets/images/filminn/unnamed (2).webp";
import eservisPhoto1 from "../assets/images/eservis/photo1.png";
import eservisPhoto2 from "../assets/images/eservis/photo2.png";
import siteDesk from "../assets/images/photos/site-desk.jpg";
import siteWork from "../assets/images/personal-website/work.png";
import siteAbout from "../assets/images/personal-website/about.png";

export const KIND = { OWN: "Kendi ürünüm", CLIENT: "Müşteri projesi" };

/**
 * tile.variant: photo | image | contain | browser | phone | pair | logo
 * links: yalnızca canlı (HTTP 200) adresler
 */
export const projects = [
    /* ------------------------------ Müşteri ------------------------------ */
    {
        slug: "supsis-ai",
        title: "Supsis AI",
        kind: KIND.CLIENT,
        client: "Supsis (Softcand)",
        sector: "Müşteri iletişimi · SaaS",
        year: "2024 – 2026",
        blurb: "Çok kanallı müşteri iletişim platformunun mobil uygulaması ve CRM otomasyonları",
        services: ["Mobil uygulama", "Backend entegrasyonu", "CRM otomasyonu"],
        stack: ["Flutter", "WebRTC", "Socket.IO", "Firebase", "Node.js"],
        description:
            "Supsis AI; WhatsApp, Instagram, e-posta ve canlı sohbet gibi 20'den fazla kanalı tek panelde toplayan, yapay zekâ asistanı ve CRM'i olan bir müşteri iletişim platformu. Platformun temsilci tarafı mobil uygulamasını Flutter ile geliştirdim: gerçek zamanlı sohbet, sesli ve görüntülü görüşme (WebRTC), SupHi yapay zekâ asistanı, destek talepleri, takvim ve raporlar. Ayrıca platformun CRM otomasyon katmanında çalıştım. Uygulama App Store'da yayında ve 400'den fazla marka tarafından kullanılan platformun parçası.",
        links: [
            { label: "App Store", href: "https://apps.apple.com/tr/app/supsis-ai/id6474663686" },
            { label: "supsis.com", href: "https://www.supsis.com/" },
        ],
        tile: { variant: "contain", aspect: "square", bg: "#f1ecfb", src: supsisInbox, pad: "10%" },
        gallery: [supsisWidget, supsisLogo],
        logo: supsisLogo,
        featured: true,
    },
    {
        slug: "enterup-tekmer-portal",
        title: "Enter-Up TEKMER Portalı",
        kind: KIND.CLIENT,
        client: "Enter-Up (Softcand)",
        sector: "Girişimcilik · Kamu entegrasyonu",
        year: "2026",
        blurb: "Teknoloji geliştirme merkezleri için uçtan uca dijital yönetim portalı",
        services: ["Web uygulaması", "Yönetim paneli", "Backend & API"],
        stack: ["React 19", "TypeScript", "Tailwind", "Node.js", "MongoDB", "KOSGEB API"],
        description:
            "TEKMER'lerin (KOSGEB destekli teknoloji geliştirme merkezleri) günlük işleyişini tek portalda toplayan bir yönetim sistemi: girişimci ön başvuruları, firma ve proje takibi, personel bildirimleri, dönemsel ilerleme raporları, dinamik form oluşturucu, etkinlik yönetimi, kira takibi ve KOSGEB entegrasyonu. Çok kiracılı (multi-tenant) mimariyle her merkez kendi alan adında çalışıyor. Ön yüzü React ve TypeScript, arka yüzü Node.js ve MongoDB ile geliştirdim; PDF ve Excel raporlama, e-posta bildirimleri ve yapay zekâ destekli içerik üretimi dahil.",
        links: [{ label: "Portal bilgi sayfası", href: "https://bilgi.portal.enter-up.com/" }],
        tile: { variant: "browser", aspect: "portrait", bg: "#0f1b3d", src: enterupDashboard, position: "0% 0%" },
        gallery: [enterupKanban, enterupReports],
        logo: enterupLogo,
        featured: true,
    },
    {
        slug: "healife",
        title: "Healife",
        kind: KIND.CLIENT,
        client: "Healife",
        sector: "Sağlık · Fitness",
        year: "2026",
        blurb: "Biyometrik verilerden kişisel antrenman ve beslenme planı üreten yapay zekâ koçu",
        services: ["Mobil uygulama", "Backend & yapay zekâ", "Web sitesi ve satış hunisi"],
        stack: ["Flutter", "Riverpod", "Node.js", "OpenAI", "RevenueCat", "Firebase"],
        description:
            "Healife, kullanıcının vücut ölçüleri ve yaşam tarzından yola çıkarak kişiye özel antrenman, beslenme ve toparlanma planları üreten bir yapay zekâ fitness koçu. Flutter mobil uygulamasını, OpenAI tabanlı koç servisini ve Node.js arka ucunu geliştirdim; abonelik, adım sayar, harita ve çoklu dil (8 dil) desteği dahil. Ayrıca hea-life.com tanıtım sitesini ve web üzerinden abonelik satış hunisini yaptım. Uygulama App Store ve Google Play'de yayında.",
        links: [
            { label: "App Store", href: "https://apps.apple.com/app/id6761519395" },
            { label: "Google Play", href: "https://play.google.com/store/apps/details?id=com.dcp.humanos" },
            { label: "hea-life.com", href: "https://hea-life.com/" },
        ],
        tile: { variant: "image", aspect: "portrait", bg: "#d7f36a", src: healifeStore1, position: "50% 0%" },
        gallery: [healifeStore2, healifeGym],
        logo: healifeLogo,
        featured: true,
    },
    {
        slug: "finrend",
        title: "Finrend",
        kind: KIND.CLIENT,
        client: "Finrend",
        sector: "Fintech · Borsa analizi",
        year: "2022 – 2026",
        blurb: "Hisse analizi, projeksiyon ve yapay zekâ yorumları sunan yatırım platformu",
        services: ["Mobil uygulama", "Web paneli", "Yapay zekâ veri hattı"],
        stack: ["Flutter", "React", "TypeScript", "Python", "PostgreSQL"],
        description:
            "Finrend; hisse analizi, temettü ve halka arz takibi, projeksiyonlar ve FinChat gibi modülleri olan bir yatırım platformu. Flutter mobil uygulamasını ve React tabanlı web panelini geliştirdim. Platformun arkasında 5.000'den fazla hisse ve kripto sembolü için günlük yapay zekâ analizi üreten bir Python veri hattı çalışıyor.",
        links: [{ label: "finrend.com", href: "http://finrend.com/" }],
        tile: { variant: "contain", aspect: "portrait", bg: "#eef1ff", src: finrendPhone, pad: "8%" },
        gallery: [finrendDesktop],
        logo: finrendIcon,
        featured: true,
    },
    {
        slug: "plus-one",
        title: "Plus One: A Wedding Horror",
        kind: KIND.OWN,
        client: "Samo Games",
        sector: "Oyun · PC (Steam)",
        year: "2026 – 2027",
        blurb: "1-4 kişilik kooperatif düğün korku-komedisi; Steam'de 2027'de çıkıyor",
        services: ["Oyun geliştirme", "Çok oyunculu ağ", "Steam yayını"],
        stack: ["Unity 6", "URP", "FishNet", "Steam Networking", "ElevenLabs"],
        description:
            "Plus One, bir düğünde geçen 1-4 kişilik kooperatif korku-komedi oyunu; tek başına oynayanlar için yapay zekâ arkadaşlar var. Unity 6 ve URP ile geliştiriyorum; çok oyunculu altyapı FishNet ve Steam ağı üzerinde, DJ repliklerini ElevenLabs ile üretiyorum. Steam sayfası 2027 başında açılacak.",
        links: [],
        tile: { variant: "image", aspect: "square", bg: "#0b0b14", src: plusoneCapsule, position: "50% 50%" },
        gallery: [plusoneDinner, plusoneChase, plusonePoster],
        featured: true,
    },
    {
        slug: "wecosmetic",
        title: "We Cosmetic",
        kind: KIND.CLIENT,
        client: "Valentura Teknoloji",
        sector: "E-ticaret · Kozmetik",
        year: "2026",
        blurb: "Türkiye pazarı için iyzico, e-arşiv ve kargo entegrasyonlu kozmetik e-ticaret platformu",
        services: ["E-ticaret sitesi", "Backend", "Entegrasyonlar"],
        stack: ["Next.js 15", "Medusa", "PostgreSQL", "Redis", "Cloudflare R2"],
        description:
            "Kozmetik ürünleri için uçtan uca e-ticaret platformu: Medusa tabanlı arka uç, Next.js vitrin, iyzico ödeme, GİB e-arşiv fatura ve Yurtiçi/Aras kargo entegrasyonları.",
        links: [],
        tile: { variant: "image", aspect: "portrait", bg: "#f6efe9", src: wecosmeticHome, position: "50% 0%" },
        gallery: [wecosmeticHero],
    },
    {
        slug: "eservis",
        title: "e-Servis",
        kind: KIND.CLIENT,
        client: "e-Servis",
        sector: "Pazaryeri · Lojistik",
        year: "2023 – 2026",
        blurb: "Servis takip platformu, organik ürün pazaryeri ve kurye rotalama çözümleri",
        services: ["Backend & API", "Mobil uygulama", "Pazaryeri"],
        stack: ["Node.js", "Laravel", "React Native", "MySQL"],
        description:
            "e-Servis ile uzun soluklu bir iş birliği: okul servislerini velilerin canlı takip edebildiği platformun REST mimarisini kurdum; ardından kapıda ödemeli organik ürün pazaryeri (satıcı onayı, mesajlaşma, kargo takibi, iki aşamalı giriş) ve React Native mobil uygulaması geldi.",
        links: [],
        tile: { variant: "image", aspect: "square", bg: "#eef6ff", src: eservisPhoto1, position: "50% 0%" },
        gallery: [eservisPhoto2],
        logo: eservisLogo,
    },
    {
        slug: "aybu-mobile",
        title: "AYBÜ Mobil",
        kind: KIND.CLIENT,
        client: "Ankara Yıldırım Beyazıt Üniversitesi",
        sector: "Eğitim · Üniversite",
        year: "2022 – 2023",
        blurb: "Öğrenci ve personel için ders programı, yemek listesi ve duyuru uygulaması",
        services: ["Mobil uygulama", "Backend"],
        stack: ["React Native", "Node.js", "MongoDB"],
        description:
            "Ankara Yıldırım Beyazıt Üniversitesi öğrencileri ve personeli için geliştirilen mobil uygulama: ders programı, günlük yemek menüsü, duyurular ve kampüs bilgileri. Mobil tarafı React Native, arka ucu Node.js ile geliştirdim.",
        links: [
            { label: "Google Play", href: "https://play.google.com/store/apps/details?id=com.aybumobile&gl=TR" },
            { label: "GitHub", href: "https://github.com/thesammet/aybumobile" },
        ],
        tile: { variant: "image", aspect: "portrait", bg: "#0b2a5b", src: aybuFeature, position: "50% 50%" },
        gallery: [aybuPhoto1, aybuPhoto2],
    },
    {
        slug: "playland-mobile",
        title: "Playland Mobil",
        kind: KIND.CLIENT,
        client: "Playland",
        sector: "Eğlence · QR ödeme",
        year: "2022",
        blurb: "Eğlence merkezleri zinciri için QR ile ödeme ve kampanya uygulaması",
        services: ["Mobil uygulama"],
        stack: ["React Native", "iyzico"],
        description:
            "Türkiye'nin birçok ilinde eğlence merkezi olan Playland için QR kodla ödeme, bakiye yükleme ve kampanya takibi yapılan mobil uygulama. iyzico altyapısıyla ödeme alıyor.",
        links: [
            { label: "Google Play", href: "https://play.google.com/store/apps/details?id=com.playlandmobile&hl=tr&gl=US" },
            { label: "App Store", href: "https://apps.apple.com/tr/app/playland-mobil/id1631854531" },
        ],
        tile: { variant: "image", aspect: "square", bg: "#1b3fd6", src: playlandFeature, position: "50% 50%" },
        gallery: [playlandPhoto1, playlandPhoto2],
        featured: true,
    },
    {
        slug: "turkiye-genclik-odulleri",
        title: "Türkiye Gençlik Ödülleri",
        kind: KIND.CLIENT,
        client: "Valentura",
        sector: "Etkinlik · Oylama",
        year: "2022",
        blurb: "Ödül töreni için aday inceleme, oylama ve haber uygulaması",
        services: ["Mobil uygulama"],
        stack: ["Flutter", "Django REST"],
        description:
            "Her yıl düzenlenen Türkiye Gençlik Ödülleri için kategorileri ve adayları gösteren, oylama ve anlık bildirim özellikleri olan mobil uygulama. Flutter ile geliştirildi, arka ucu Django REST Framework.",
        links: [
            { label: "Google Play", href: "https://play.google.com/store/apps/details?id=com.valentura.turkiyegenclikodulleri&hl=tr&gl=US" },
            { label: "App Store", href: "https://apps.apple.com/us/app/t%C3%BCrkiye-gen%C3%A7lik-%C3%B6d%C3%BClleri/id1615945419" },
        ],
        tile: { variant: "image", aspect: "portrait", bg: "#0a0a0a", src: tgoFeature, position: "50% 50%" },
        gallery: [tgoPhoto1, tgoPhoto2],
        logo: valenturaLogo,
    },
    {
        slug: "noor-technology",
        title: "Noor Technology",
        kind: KIND.CLIENT,
        client: "Noor Technology",
        sector: "IoT · Hava kalitesi",
        year: "2022",
        blurb: "Hava temizleme cihazlarını yöneten ve hava kalitesini izleyen IoT uygulaması",
        services: ["Mobil uygulama", "IoT entegrasyonu"],
        stack: ["Flutter", "MQTT"],
        description:
            "Noor Technology'nin hava temizleme cihazlarıyla eşleşen, altı farklı hava kalitesi verisini gösteren ve cihazı uzaktan kontrol eden mobil uygulama.",
        links: [],
        tile: { variant: "image", aspect: "square", bg: "#eaf4fb", src: noorFeature, position: "50% 50%" },
        gallery: [noorPhoto1, noorPhoto2],
    },
    {
        slug: "funlord-mobile",
        title: "Funlord Mobil",
        kind: KIND.CLIENT,
        client: "Funlord",
        sector: "Eğlence",
        year: "2023",
        blurb: "Eğlence merkezleri için kart bakiyesi, sıra ve oyun takibi uygulaması",
        services: ["Mobil uygulama"],
        stack: ["React Native"],
        description:
            "Funlord eğlence merkezleri için gişe sırasını azaltan, kart bakiyesi ve kazanılan biletleri gösteren mobil uygulama.",
        links: [],
        tile: { variant: "image", aspect: "portrait", bg: "#4b22c9", src: funlordFeature, position: "50% 50%" },
        gallery: [funlordPhoto1, funlordPhoto2],
    },
    {
        slug: "vocan",
        title: "Vocan",
        kind: KIND.OWN,
        client: "Kendi ürünüm",
        sector: "Eğitim · Dil",
        year: "2022 – 2023",
        blurb: "80'den fazla dilde çeviri ve aralıklı tekrarla kelime öğrenme uygulaması",
        services: ["Mobil uygulama", "Backend"],
        stack: ["React Native", "Node.js", "MongoDB"],
        description:
            "Vocan; çeviri, geçmiş ve favoriler ile aralıklı tekrar algoritmasıyla kelime ezberleten bir dil öğrenme uygulaması. Tam yığın bir kişisel projem; kodu GitHub'da açık.",
        links: [{ label: "GitHub", href: "https://github.com/thesammet/vocan" }],
        tile: { variant: "image", aspect: "portrait", bg: "#0a1a3a", src: vocanFeature, position: "50% 50%" },
        gallery: [vocanPhoto1, vocanPhoto2],
    },
    {
        slug: "filminn",
        title: "Film Inn",
        kind: KIND.OWN,
        client: "Kendi ürünüm",
        sector: "Eğlence · İçerik",
        year: "2022",
        blurb: "Film ve dizi incelemeleri, haberler ve favori listeleri",
        services: ["Mobil uygulama", "Web"],
        stack: ["Flutter", "Firebase"],
        description:
            "Film ve dizi inceleme, haber ve liste uygulaması. Flutter ile geliştirildi, veriler Firebase Realtime Database'de; web sürümü Vercel'de yayında, kodu açık.",
        links: [
            { label: "Web", href: "https://filminn.vercel.app/" },
            { label: "GitHub", href: "https://github.com/thesammet/filminn" },
        ],
        tile: { variant: "image", aspect: "square", bg: "#0a0a0a", src: filminnFeature, position: "50% 50%" },
        gallery: [filminnPhoto1, filminnPhoto2],
    },

    /* --------------------------- Kendi ürünlerim -------------------------- */
    {
        slug: "sonora-ai",
        title: "Sumo AI",
        kind: KIND.OWN,
        client: "Kendi ürünüm",
        sector: "Müzik · Yapay zekâ",
        year: "2024 – 2026",
        blurb: "Sözleri yazın, tarzı seçin: yapay zekâ ile şarkı üreten uygulama, 110K+ indirme",
        services: ["Mobil uygulama", "Backend & yapay zekâ", "Abonelik"],
        stack: ["Flutter", "Node.js", "MongoDB", "RevenueCat", "AppsFlyer"],
        description:
            "Sumo AI, sözlerini yazdığınız ya da rastgele ürettirdiğiniz şarkıları seçtiğiniz tarzda besteleyen bir yapay zekâ müzik uygulaması. Kütüphane, keşfet, ses klonlama ve şarkı araçları; 8 dil desteği; abonelik ve kredi sistemi. Uygulamayı, arka ucunu ve büyüme tarafını (AppsFlyer, mağaza optimizasyonu) tek başıma yürüttüm. Google Play'de yayında, 110 binden fazla indirme.",
        links: [{ label: "Google Play", href: "https://play.google.com/store/apps/details?id=ai.sonora" }],
        tile: { variant: "photo", aspect: "square", src: sonoraCrowd, screen: sonoraInApp, position: "50% 40%" },
        gallery: [sonoraScreen1, sonoraScreen2, sonoraGirl],
        landing: "/sonora-ai",
        product: true,
    },
    {
        slug: "funo-ai",
        title: "Funo AI",
        kind: KIND.OWN,
        client: "Kendi ürünüm",
        sector: "Ses · Yapay zekâ",
        year: "2025 – 2026",
        blurb: "Sesinizi 100'den fazla karakter ve ünlü sesine dönüştüren uygulama",
        services: ["Mobil uygulama", "Backend & yapay zekâ", "Reklam ve abonelik"],
        stack: ["Flutter", "Node.js", "ElevenLabs", "Google Ads", "RevenueCat"],
        description:
            "Funo AI; kaydettiğiniz ya da yüklediğiniz sesi 100'den fazla karakter ve ünlü sesine çeviren bir ses değiştirme uygulaması. Kredi ve reklam ödüllü model, abonelik, ffmpeg tabanlı ses işleme. Hem App Store hem Google Play'de yayında.",
        links: [
            { label: "Google Play", href: "https://play.google.com/store/apps/details?id=com.funoai.voicechanger" },
            { label: "App Store", href: "https://apps.apple.com/app/id6747037537" },
        ],
        tile: { variant: "photo", aspect: "portrait", src: funoDesk, position: "30% 50%" },
        gallery: [funoKeyart, funoInApp],
        landing: "/funo",
        product: true,
    },
    {
        slug: "tattoo-ai",
        title: "Tattoo AI",
        kind: KIND.OWN,
        client: "Kendi ürünüm",
        sector: "Tasarım · Yapay zekâ",
        year: "2026",
        blurb: "Dövme tasarımı üreten ve tenin üzerinde önizleten uygulama",
        services: ["Mobil uygulama", "Backend & yapay zekâ"],
        stack: ["Flutter", "Node.js", "fal.ai", "OpenAI", "Cloudinary"],
        description:
            "Tattoo AI; metinden dövme tasarımı üretme, kendi fotoğrafınızın üzerinde deneme, portre ve evcil hayvan dövmeleri, yara kapatma ve yapay zekâ dövme sanatçısıyla sohbet gibi araçlar sunar. Görsel üretimi fal.ai, sohbet OpenAI ile.",
        links: [],
        tile: { variant: "photo", aspect: "square", src: tattooPortrait, screen: tattooInApp, position: "30% 50%", screenSide: "right" },
        gallery: [tattooInApp],
        landing: "/tattooai",
        product: true,
    },
    {
        slug: "meriastro",
        title: "Meriastro",
        kind: KIND.OWN,
        client: "Kendi ürünüm",
        sector: "Astroloji · İçerik",
        year: "2025",
        blurb: "Günlük burç ve tarot yorumlarını yapay zekâ ile yazan uygulama",
        services: ["Mobil uygulama", "Backend & yapay zekâ"],
        stack: ["Flutter", "Node.js", "OpenAI"],
        description:
            "Meriastro, günlük burç yorumları, tarot ve gök olayları içeriklerini yapay zekâ ile kişiselleştirerek sunan bir astroloji uygulaması. Google Play'de yayında.",
        links: [{ label: "Google Play", href: "https://play.google.com/store/apps/details?id=com.meriastro.meriastro" }],
        tile: { variant: "image", aspect: "portrait", bg: "#120a2a", src: meriastroSky, position: "50% 50%" },
        gallery: [meriastroMockup],
        landing: "/meriastro",
        product: true,
    },
    {
        slug: "revoai",
        title: "RevoAI",
        kind: KIND.OWN,
        client: "Kendi ürünüm",
        sector: "İç mimari · Yapay zekâ",
        year: "2025",
        blurb: "Tek fotoğraftan iç mekân, dış cephe ve bahçe tasarımı üreten uygulama",
        services: ["Mobil uygulama", "Backend & yapay zekâ"],
        stack: ["Flutter", "Node.js", "Görüntü üretim modelleri"],
        description:
            "RevoAI, çektiğiniz bir fotoğraftan farklı tarzlarda iç mekân, dış cephe ve peyzaj tasarımları üretir; önce/sonra karşılaştırması ve mobilya önerileri sunar. Google Play'de yayında.",
        links: [{ label: "Google Play", href: "https://play.google.com/store/apps/details?id=io.interiorai.home.ai" }],
        tile: { variant: "image", aspect: "square", bg: "#1c1c1c", src: revoaiInterior, position: "50% 50%" },
        gallery: [revoaiMockup],
        landing: "/revoai",
        product: true,
    },
    {
        slug: "enclave",
        title: "Enclave",
        kind: KIND.OWN,
        client: "Kendi ürünüm · WebMCP Challenge",
        sector: "Yapay zekâ · Web",
        year: "2026",
        blurb: "Verileri tarayıcıdan çıkarmadan yapay zekâ ajanının yönetebildiği arka ofis uygulaması",
        services: ["Web uygulaması", "Yapay zekâ araçları"],
        stack: ["React", "TypeScript", "DuckDB-WASM", "WebMCP"],
        description:
            "Enclave, bir e-ticaret arka ofisini tamamen tarayıcıda (DuckDB-WASM) çalıştırır ve yapay zekâ ajanına verilerin kendisini değil, 22 adet WebMCP aracını sunar; her değişiklik insan onayından geçer. WebMCP Challenge için geliştirildi, canlı demo açık.",
        links: [{ label: "Canlı demo", href: "https://enclave-bay.vercel.app" }],
        tile: { variant: "browser", aspect: "square", bg: "#0e0e11", src: enclaveShot, position: "50% 0%" },
        gallery: [],
    },

    /* ------------------------ Era-Lab Studio ürünleri -------------------- */
    {
        slug: "abdusamedakgul-com",
        title: "abdusamedakgul.com",
        kind: KIND.OWN,
        client: "Kendi ürünüm",
        sector: "Web",
        year: "2024 – 2026",
        blurb: "Bu site: React ve Tailwind ile, her push'ta otomatik yayınlanan portfolyo",
        services: ["Web sitesi"],
        stack: ["React", "Tailwind CSS", "Framer Motion"],
        description: "Bu site. React ve Tailwind CSS ile yazıldı; uygulamaların tanıtım, gizlilik ve hesap silme sayfalarını da barındırıyor. GitHub'a her push'ta otomatik yayınlanıyor.",
        links: [{ label: "abdusamedakgul.com", href: "https://abdusamedakgul.com/" }],
        tile: { variant: "image", aspect: "square", bg: "#f3f4f6", src: siteDesk, position: "50% 50%" },
        gallery: [siteWork, siteAbout],
    },
];

export const featuredProjects = projects.filter((p) => p.featured);
export const ownProducts = projects.filter((p) => p.product);
export const clientProjects = projects.filter((p) => p.kind === KIND.CLIENT);
export const ownProjects = projects.filter((p) => p.kind === KIND.OWN);
export const findProject = (slug) => projects.find((p) => p.slug === slug);

/** Logo şeridi için birlikte çalışılan markalar (yalnızca logosu olanlar görsel, diğerleri metin). */
export const brands = [
    { name: "Supsis AI", logo: supsisLogo },
    { name: "Enter-Up", logo: enterupLogo },
    { name: "Healife", logo: healifeLogo },
    { name: "Valentura", logo: valenturaLogo },
    { name: "Finrend", logo: finrendIcon },
    { name: "e-Servis", logo: eservisLogo },
    { name: "AYBÜ" },
    { name: "Playland" },
    { name: "Noor Technology" },
];
